// CORE
// Este é um arquivo core do boilerplate e modificações neste arquivo serão bloqueadas via pré-hook de commit.
// Fazemos este bloqueio para manter a consistência do boilerplate e diminuir as chances de conflitos nos updates.
// Caso possível, procure uma alternativa ao uso deste arquivo.
// Se a alteração for realmente necessária ou for um update do boilerplate,
// realize o commit usando o comando 'git commit --no-verify'.

import { colorTokens } from '../colors';
import { inter } from '../fonts';

export const MuiCard = {
  styleOverrides: {
    root: {
      borderRadius: '8px',
      boxShadow: 'none',
      backgroundColor: colorTokens.white,
      border: `1px solid ${colorTokens.border.default}`,
      fontFamily: inter.style.fontFamily,
    },
  },
};

export const MuiCardHeader = {
  styleOverrides: {
    root: {},
    title: {
      fontSize: '20px',
      fontWeight: 700,
      fontFamily: inter.style.fontFamily,
    },
    subheader: {
      fontFamily: inter.style.fontFamily,
    },
  },
};

export const MuiCardContent = {
  styleOverrides: {
    root: {
      fontFamily: inter.style.fontFamily,
    },
  },
};

export const MuiCardActions = {
  styleOverrides: {
    root: {
      fontFamily: inter.style.fontFamily,
    },
  },
};
